import {Field} from 'formik';
import {FormikSelect, FormikTextInput} from '@flexinet/ui-components';

export const FilterFormComponent = () => {
    return (
        <>
            <Field
                name="pipelineType"
                label="Pipeline Type"
                component={FormikSelect}
                data={[
                    {value: 'APPLICATION', label: 'Application'},
                    {value: 'API', label: 'API'},
                    {value: 'DATABASE', label: 'Database'},
                    {value: 'INFRASTRUCTURE', label: 'Infrastructure'},
                    {value: 'LIBRARY', label: 'Library'},
                    {value: 'SERVICE', label: 'Service'},
                ]}
                clearable
                my="md"
            />
            <Field
                name="pipelineStatus"
                label="Pipeline Status"
                component={FormikSelect}
                data={[
                    {value: 'CREATING', label: 'Creating'},
                    {value: 'ACTIVE', label: 'Active'},
                    {value: 'UPDATING', label: 'Updating'},
                    {value: 'FAILED', label: 'Failed'},
                    {value: 'DELETING', label: 'Deleting'},
                    {value: 'ARCHIVED', label: 'Archived'},
                ]}
                clearable
                my="md"
            />
            <Field
                name="codeRepositoryName"
                label="Code Repository Name"
                component={FormikTextInput}
                my="md"
            />
        </>
    );
};
